module.exports = __webpack_public_path__ + "static/media/avatar40.7aebf783.png";